import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[routerLink]',
})
export class RouterLinkDirective {
  @HostBinding('class')
  className = 'routable-link';
}
